import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Checklist } from 'src/app/models/checklist.model';
import { Organisation } from 'src/app/models/organisation.model';
import { CommonService } from 'src/app/services/common.service';
import { constants } from 'src/app/utils/constants';
import * as states from 'src/app/utils/states.json';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
  standalone: false
})
export class AddressComponent  implements OnInit {

  public accessibleMode: string = '';
  public addressTypeList: any[] = [];
  public stateList: any = (states as any).default;
  public addressList: any = [];
  public index: any = [];
  public isValid: boolean = false;
  public itemId: string = '';
  public addressForm: FormGroup;
  public organisationInfo: Organisation|any;

  @ViewChild('content') private content: any;

  constructor(
    private formBuilder: FormBuilder,
    private navController: NavController,
    private router: Router,
    private commonService: CommonService,
  ) {
    this.addressForm = this.formBuilder.group({
      addresses: this.formBuilder.array([])
    });
  }

  async ngOnInit() {
    this.addressTypeList = this.commonService.getSelectedItem('ADDRESS_TYPE');
    await this.initializeApp();
    if (this.accessibleMode != constants.VIEW && this.accessibleMode != constants.EDIT) {
      this.organisationInfo = await this.commonService.getItem(constants.ORGANISATION);
      this.addresses.at(0).get('state')?.setValue(this.organisationInfo.state);
    }
    this.commonService.pushCurrentTabPosition(2);
  }

  async initializeApp() {
    if (this.router?.getCurrentNavigation()?.extras.state?.['queryParams'].itemId) {
      this.accessibleMode = this.router?.getCurrentNavigation()?.extras.state?.['queryParams'].accessibleMode;
      this.itemId = this.router?.getCurrentNavigation()?.extras.state?.['queryParams'].itemId;
      const checkItem: Checklist = await this.commonService.getItem(this.itemId);
      if ((this.accessibleMode === constants.VIEW || this.accessibleMode === constants.EDIT) 
      && (JSON.stringify(checkItem.address) !== '{}' || JSON.stringify(checkItem.address) !== '[]')
      && !this.commonService.checkIfArrayEmpty(JSON.parse(JSON.stringify(checkItem.address)))) {
        this.commonService.setCurrentMode(this.accessibleMode, checkItem);
        this.addressList = checkItem.address;

        for (const item of this.addressList) {
          if (item) {
            const addressGroup = this.formBuilder.group({
              type: [item.type, Validators.required],
              name: [item.name, [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC_SPECIAL_CHARS)]],
              address: [item.address, [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC_SPECIAL_CHARS)]],
              postCode: [item.postCode,[Validators.required, Validators.pattern(constants.REGEX.NUMERIC)]],
              state: [item.state, Validators.required],
              comment: [item.comment, [Validators.pattern(constants.REGEX.ALPHA_NUMERIC_SPECIAL_CHARS)]]
            });
            this.addresses.push(addressGroup);
          }
        }
      } else {
        this.addAddress(true);
      }
      this.isValidData();
    } else {
      await this.navController.navigateForward(constants.PAGE.CHECKLIST);
    }
  }

  get addresses(): FormArray {
    return this.addressForm.get('addresses') as FormArray;
  }

  public addAddress(isdefault?: boolean) {
    const addressGroup = this.formBuilder.group({
      type: [isdefault ? 'Field' : constants.EMPTY, Validators.required],
      name: [constants.EMPTY, [Validators.required, Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC_SPECIAL_CHARS)]],
      address: [constants.EMPTY, [Validators.required, Validators.pattern(constants.REGEX.ALPHA_NUMERIC_SPECIAL_CHARS)]],
      postCode: [constants.EMPTY,[Validators.required, Validators.pattern(constants.REGEX.NUMERIC)]],
      state: [constants.EMPTY, Validators.required],
      comment: [constants.EMPTY, [Validators.pattern(constants.REGEX.ALPHA_NUMERIC_SPECIAL_CHARS)]]
    });


    if (!this.addresses || this.addresses.length < 3) {
      this.addresses.push(addressGroup);
      this.content?.scrollToBottom(300);
      //this.isValidData();
    }
  }

  public removeAddress(addressIndex: number) {
    this.addresses.removeAt(addressIndex);
    this.isValidData();
  }

  public isValidData() {
    for (let element of this.addressList) {
      if (element.type === '') {
        this.isValid = false;
      }
      else if (element.name == '') {
        this.isValid = false;
      }
      else if (element.state === '') {
        this.isValid = false;
      }
      else {
        this.isValid = true;
      }
    }
  }

  public setStateByPostcode(postCode: any, idx: number) {
    var reg = /^\d+$/;
    if (!reg.test(postCode)) {
      this.addresses.at(idx).patchValue({ postCode: '', state: '' });      
      //alert('Post code is only number');
    }
    else if (postCode >= 7000 && postCode <= 7799) {
      this.addresses.at(idx).patchValue({ state: 'TAS' });
    }
    else if (postCode >= 6000 && postCode <= 6797) {
      this.addresses.at(idx).patchValue({ state: 'WA' });
    }
    else if (postCode >= 5000 && postCode <= 5799) {
      this.addresses.at(idx).patchValue({ state: 'SA' });
    }
    else if (postCode >= 4000 && postCode <= 4999) {
      this.addresses.at(idx).patchValue({ state: 'QLD' });
    }
    else if (postCode >= 3000 && postCode <= 3999) {
      this.addresses.at(idx).patchValue({ state: 'VIC' });
    }
    else if (postCode >= 800 && postCode <= 899) {
      this.addresses.at(idx).patchValue({ state: 'NT' });
    }
    else if ((postCode >= 2600 && postCode <= 2618) || (postCode >= 2900 && postCode <= 2920)) {
      this.addresses.at(idx).patchValue({ state: 'ACT' });
    }
    else if ((postCode >= 2000 && postCode <= 2599) || (postCode >= 2619 && postCode <= 2899) || (postCode >= 2921 && postCode <= 2999)) {
      //this.addressLst[idx].state = 'NSW';
      this.addresses.at(idx).patchValue({ state: 'NSW' });
    }
    this.isValidData();
  }

  public async nextPage() {
    if (!this.addressForm.valid) {
      this.addressForm.markAllAsTouched();
    }
    else {
      this.commonService.pushCurrentTabPosition(3);
      let navigationExtras: NavigationExtras = {
        state: {
          queryParams: {
            accessibleMode: this.accessibleMode,
            itemId: this.itemId
          }
        }
      };
      if (this.accessibleMode === constants.VIEW) {
        await this.navController.navigateForward(constants.PAGE.PARTIES, navigationExtras);
        // this.router.navigate([constants.PAGE.PARTIES], navigationExtras);
      } else if (this.accessibleMode === constants.NEW || this.accessibleMode === constants.EDIT) {
        this.addressList = this.addressForm.get('addresses')?.value;
        var returnItemId: string = await this.commonService.insertChecklistItem(this.itemId, constants.ADDRESS, this.addressList);
        if (this.itemId === returnItemId) {
          await this.navController.navigateForward(constants.PAGE.PARTIES, navigationExtras);
          // this.router.navigate([constants.PAGE.PARTIES], navigationExtras);
        }
      }
      else {
        await this.navController.navigateBack(constants.PAGE.CHECKLIST, { replaceUrl: true });
        // this.router.navigate([constants.PAGE.CHECKLIST], { replaceUrl: true });
      }
    }
  }

  public backToPage() {
    this.commonService.pushCurrentTabPosition(1);
    let navigationExtras: NavigationExtras = {
      state: {
        queryParams: {
          accessibleMode: this.accessibleMode,
          itemId: this.itemId
        }
      }
    };
    this.navController.navigateBack(constants.PAGE.ORGANISATION, navigationExtras);
    // this.router.navigate([constants.PAGE.ORGANISATION], navigationExtras);

  }

}
